'use client';
import React from 'react';
import {
  createClient,
  StructuredContentProvider,
} from '@nerdwallet/structured-content-core';
import components from '~/app/lib/sc-components';
import dynamic from 'next/dynamic';
import schema from '@nerdwallet/structured-content/schema';
import { useInitializeGtm } from '../lib/initializeGtm';
import { getPageTaxonomy } from '../lib/page-taxonomy';
import { usePathname } from 'next/navigation';
import BounceTracking from '../components/bounce-tracking';
import SegmentTracking from '../lib/segment/SegmentTracking';
import FrontPageCombinedContainer from './variants/front-page-combined-container';
import { NewsArticlesQuery } from '~/generated-graphql/generated-types';
import { TreasuryRates } from '../queries/types';
import FrontPageContainer from './variants/front-page-container';

interface Props {
  variant: string;
  articles?: NewsArticlesQuery | undefined;
  socialVideos?: string[] | undefined;
  treasuryRates?: TreasuryRates;
}

const FrontPageMainWrapper = ({
  variant,
  articles,
  socialVideos,
  treasuryRates,
}: Props): JSX.Element => {
  const client = createClient({
    components: components as any,
    schema,
    codesplittingFunction: (asyncImport, exportName) =>
      dynamic(() =>
        asyncImport.then((mod) => ({
          default: mod[exportName],
        })),
      ),
  });

  useInitializeGtm({ pageTaxonomy: getPageTaxonomy(usePathname()) ?? [] });

  return (
    <React.Fragment>
      <BounceTracking />
      <SegmentTracking segmentPageName="homepage">
        <StructuredContentProvider client={client}>
          {variant === 'control' ? (
            <FrontPageContainer
              articlesData={articles}
              socialVideos={socialVideos}
              treasuryRates={treasuryRates}
            />
          ) : (
            <FrontPageCombinedContainer
              articlesData={articles}
              socialVideos={socialVideos}
              treasuryRates={treasuryRates}
            />
          )}
        </StructuredContentProvider>
      </SegmentTracking>
    </React.Fragment>
  );
};

export default FrontPageMainWrapper;
